var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterListFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.889 18.5a1.1 1.1 0 0 1-.792-.311 1.03 1.03 0 0 1-.32-.772q0-.461.32-.772a1.1 1.1 0 0 1 .792-.312h2.222q.473 0 .792.312.32.311.32.772 0 .46-.32.771a1.1 1.1 0 0 1-.792.312zm-4.445-5.417a1.1 1.1 0 0 1-.791-.311 1.03 1.03 0 0 1-.32-.772q0-.46.32-.772a1.1 1.1 0 0 1 .791-.311h11.112q.471 0 .791.311.32.312.32.772t-.32.772a1.1 1.1 0 0 1-.791.311zM3.111 7.667a1.1 1.1 0 0 1-.792-.312A1.03 1.03 0 0 1 2 6.583q0-.46.32-.772A1.1 1.1 0 0 1 3.11 5.5H20.89q.473 0 .792.311.318.312.319.772 0 .461-.32.772a1.1 1.1 0 0 1-.791.312z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterListFill);
export default __webpack_public_path__ + "static/media/filter_list_fill.4aeb2595ffd33c04ddb15b9ecc067943.svg";
export { ForwardRef as ReactComponent };